import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class RemoveChatCcArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => String)
  email: string
}

export interface IRemoveChatCc extends IAction<Chat, RemoveChatCcArgs> {}
